import React, { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import companyLogo from "assets/abbypay-plus-logo.svg";
import Footer from "layout/footer/Footer";
import s from "./AuthLayout.module.scss";

const AuthHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

const AuthLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const headertitle = useMemo(() => {
    switch (true) {
      case location.pathname.includes("/login"):
        return (
          t("layout.siteTitle.authLogin") + t("layout.siteTitle.authSuffix")
        );
      case location.pathname.includes("/forget-password"):
        return (
          t("layout.siteTitle.authForget") + t("layout.siteTitle.authSuffix")
        );
      case location.pathname.includes("/change-password"):
        return (
          t("layout.siteTitle.authChange") + t("layout.siteTitle.authSuffix")
        );
      case location.pathname.includes("/otp-verify"):
        return t("layout.siteTitle.authOtp") + t("layout.siteTitle.authSuffix");
      default:
        return (
          t("layout.siteTitle.authLogin") + t("layout.siteTitle.authSuffix")
        );
    }
  }, [location.pathname]);

  return (
    <>
      <AuthHelmet title={headertitle} />
      <div className={s.container}>
        <div className={s.wrapper}>
          <div
            className={s.logo}
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/user/login")}
          >
            <img src={companyLogo} className={s["abbypayplus-logo"]} alt="logo" />
          </div>
          <div className={s["content-wrapper"]}>
            <div>
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
